<template>
  <div>
    <mf-card-container v-if="showUngroupedTable" :title="title" :hide-card-shadow="hideCardShadow">
      <mf-info-card v-if="isIndustryCampaign && ungroupedProducts.length > 0" variant="success" :v-html="industryRebateWarning" icon="payments" />
      <percentage-discount-table
        :ref="offerSalesType"
        class="mt-4"
        type="ungrouped"
        :products="ungroupedProducts"
        :validations="$v"
        :headers="headers"
        :helpers="helpers"
        :repeated-skus="repeatedSkus"
        :search="search"
        :is-disabled-in-rules="isDisabledInRules"
        :is-industry-campaign="isIndustryCampaign"
        :tooltip-message="tooltipMessage"
        :disabled="disabled"
        @remove-item="removeItem"
      />
    </mf-card-container>

    <div v-if="showGroupedTable">
      <h2 :class="showUngroupedTable ? 'pt-8' : ''" class="ma-0 pb-0 offers-title">Grupos na oferta</h2>
      <p class="offers-subtitle pt-3">
        {{ groupDescription }}
      </p>

      <group-card
        v-for="(group, index) in groupedProducts"
        :key="group._id"
        offer-sales-type="percentage_offer_sales"
        :group="group"
        :headers="headers"
        :helpers="helpers"
        :repeated-skus="repeatedSkus"
        :validations="$v"
        :group-index="index"
        :search="search"
        :is-disabled-in-rules="isDisabledInRules"
        :is-industry-campaign="isIndustryCampaign"
        :tooltip-message="tooltipMessage"
        :disabled="disabled"
        @remove-item="removeItem"
        @remove-group="removeGroup(group._id)"
        @change-group-exhibition="changeGroupExhibition($event, group._id)"
      />
    </div>
  </div>
</template>

<script>
import GroupCard from '../GroupCard.vue'
import PercentageDiscountTable from './PercentageDiscountTable.vue'

import { required, requiredIf } from 'vuelidate/lib/validators'
import { notOnlySpace } from '@/helpers/validators.js'
import { eansValidation, percentageDiscountValidation, minMaxPerClientValidation } from '@/modules/campanhas/gestao-ofertas-v2/helpers/validators.js'

import { offerSalesTablesContainer } from '../../../mixins/offer-sales-tables-container'
export default {
  name: 'PercentageDiscount',
  components: {
    GroupCard,
    PercentageDiscountTable,
  },
  mixins: [offerSalesTablesContainer],
  computed: {
    offerSalesType() {
      return 'percentage_offer_sales'
    },
    title() {
      return this.ungroupedProducts.length === 1
        ? '1 produto desagrupado com desconto percentual'
        : `${this.ungroupedProducts.length} produtos desagrupados com desconto percentual`
    },
    headers() {
      let headers = [
        {
          text: '',
          value: 'expandAction',
          width: '2%',
          sortable: false,
        },
        {
          text: '',
          value: 'image',
          width: '5%',
          sortable: false,
        },
        {
          text: 'SKU',
          value: 'sku',
          width: '12%',
          sortable: false,
        },
        {
          text: 'EAN',
          value: 'ean',
          width: '10%',
          sortable: false,
        },
        {
          text: 'Nome',
          value: 'name',
          width: '35%',
          sortable: false,
        },
        {
          text: 'Desconto',
          value: 'percentage_discount',
          width: '15%',
          sortable: false,
        },
        {
          text: 'Mín. CPF',
          value: 'minimum_per_client',
          width: '10.5%',
          sortable: false,
        },
        {
          text: 'Máx. CPF',
          value: 'maximum_per_client',
          width: '10.5%',
          sortable: false,
        },
        {
          text: 'Status',
          value: 'status',
          sortable: false,
          width: '',
        },
        {
          text: '',
          value: 'action',
          sortable: false,
        },
      ]
      return headers
    },
  },
  validations() {
    const fields = {
      required: requiredIf(function () {
        return this.allInputsRequired
      }),

      $each: {
        sku: requiredIf(function (group) {
          return !group.products
        }),
        name: { required, notOnlySpace },
        eans: { eansValidation },
        minMaxPerClientValidation: { minMaxPerClientValidation },
        percentage_discount: { percentageDiscountValidation },
        products: {
          $each: {
            eans: {
              eansValidation,
            },
            name: { required, notOnlySpace },
          },
        },
      },
    }
    return {
      ...(this.ungroupedProducts.length > 0
        ? {
            ungroupedProducts: { ...fields },
          }
        : {}),

      ...(this.groupedProducts.length > 0
        ? {
            groupedProducts: { ...fields },
          }
        : {}),
    }
  },
}
</script>

<style lang="scss" scoped>
.offers-subtitle {
  font-size: 16px;
  line-height: 120%;
  letter-spacing: 0.4px;
  color: $cinza-0;
  max-width: 930px;
}

.offers-title {
  font-size: 26px;
  font-weight: 700;
  color: $cinza-d10;
}
</style>
